import { useEffect, useState } from 'react';
import { GeetestConfig, GeetestSolution } from './Captcha.types';

const GEETEST_CONTAINER_ID = 'geetest-container-id' as const;
const GEETEST_SCRIPT_ID = 'geetest-script-id' as const;
const GEETEST_INIT_FN = 'initGeetest4' as const;

type GeetestUnprocessedSolution = {
  lot_number: string;
  captcha_output: string;
  pass_token: string;
  gen_time: string;
};

type GeetestError = {
  code: string;
  msg: string;
  desc: { detail: string };
};

export default function Geetest({
  onReady,
  onSuccess,
  onError,
  language,
  width,
  product,
  config,
}: Readonly<{
  onReady: () => void;
  onSuccess: (solution: GeetestSolution) => void;
  onError: (error: GeetestError) => void;
  language: string;
  width: string;
  product: 'float' | 'popup';
  config: GeetestConfig;
}>) {
  // @ts-expect-error missing window type
  const [scriptLoaded, setScriptLoaded] = useState(!!window[GEETEST_INIT_FN]);
  const [geetestObj, setGeetestObj] = useState<any>(null);

  const loadScript = () => {
    let script = document.getElementById(GEETEST_SCRIPT_ID) as HTMLScriptElement | null;

    if (!script) {
      script = document.createElement('script');
      script.id = GEETEST_SCRIPT_ID;
      script.src = 'https://static.geetest.com/v4/gt4.js';
      document.head.appendChild(script);
    }

    script.onload = () => {
      setScriptLoaded(true);
    };
  };

  useEffect(() => {
    if (!scriptLoaded) {
      loadScript();
    }
  }, []);

  useEffect(() => {
    // @ts-expect-error missing window type
    if (scriptLoaded && window[GEETEST_INIT_FN]) {
      const { gt } = config;
      // @ts-expect-error missing window type
      window[GEETEST_INIT_FN](
        {
          language,
          product,
          nativeButton: { width },
          captchaId: gt,
          onError,
        },
        (geetestObj: any) => {
          setGeetestObj(geetestObj);

          geetestObj.onReady(() => {
            geetestObj.appendTo(`#${GEETEST_CONTAINER_ID}`);
            onReady();
          });

          geetestObj.onSuccess(() => {
            const {
              lot_number: lotNumber,
              captcha_output: captchaOutput,
              pass_token: passToken,
              gen_time: genTime,
            } = geetestObj.getValidate() as GeetestUnprocessedSolution;

            onSuccess({
              lotNumber,
              captchaOutput,
              passToken,
              genTime,
            });
          });

          geetestObj.onError((e: GeetestError) => {
            onError(e);
          });
        },
      );
    }
  }, [scriptLoaded]);

  useEffect(() => {
    if (geetestObj) {
      return () => {
        geetestObj.destroy();
      };
    }
  }, [geetestObj]);

  return <div id={GEETEST_CONTAINER_ID} className="w-100" />;
}
